import { useEffect, useState } from "react";
import { getUser, hasRole, setPage, toPrettyDate, useHub, validateRole } from "../../../core/Global";
import FlexRow from "../../../components/base/FlexRow";
import Icon from "../../../components/base/Icon";
import { DataTable, DataTableField } from "../../../components/data/DataTable";
import { API_ROUTES } from "../../../core/Constants";
import Modal from "../../../components/base/Modal";
import TextBox from "../../../components/form/TextBox";
import { toastSuccess } from "../../../components/base/Toast";
import { UnitModel } from "../models/UnitModel";
import TextArea from "../../../components/form/TextArea";
import { DrawerForm } from "../../../components/drawers/DrawerForm";

export default function UnitsListView() {

  const hub = useHub()

  const [createModal, createModalSet] = useState<boolean>(false)
  const [editModal, editModalSet] = useState<boolean>(false)
  const [deleteModal, deleteModalSet] = useState<boolean>(false)

  const [selectedItem, selectedItemSet] = useState<UnitModel>()


  const [refresh, refreshSet] = useState<boolean>();

  const edit = (data: any) => {
    selectedItemSet(data);
    editModalSet(true);
  }

  const deleteUnit = (data: any) => {
    selectedItemSet(data);
    deleteModalSet(true);
  }


  const NameItem = (data: UnitModel) => (
    <FlexRow onClick={() => edit(data)}>

      <div className="ms-2">
        {data.name}
      </div>
      <a href="#" className="ms-1"
        onClick={e => {
          e.preventDefault();
          edit(data);
        }}>
        <Icon icon="edit" className="ms-2" size={12} />
      </a>
    </FlexRow>
  )

  const CreatedItem = (data: UnitModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.createdAt)}
      </div>
      {
        data.creatorUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.creatorUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  const ModifiedItem = (data: UnitModel) => (
    <div>
      <div className='d-flex align-items-center'>
        {toPrettyDate(data.modifiedAt)}
      </div>
      {
        data.modifiedUser &&
        <FlexRow className='fs-8 text-gray-600 mt-1'>
          <div>
            <Icon icon="user" className="me-2" size={10} type="solid" />
          </div>
          <div className="fs-8">
            By: {data.modifiedUser.fullName}
          </div>
        </FlexRow>
      }

    </div>
  )

  useEffect(() => {

    validateRole("ManageUnits");
    setPage("Units", "Inventory", "Base Data");

  }, [])

  useEffect(() => {
    if (refresh) {
      setTimeout(() => {
        refreshSet(false);
      }, 1000);
    }
  }, [refresh])

  return (
    <>

        <DataTable
          objectName="Unit"
          apiRoute={API_ROUTES.InventoryUnits}
          addCustom={() => createModalSet(true)}
          edit editCustom={edit}
          delete={hasRole("DeleteUnits")} deleteCustom={deleteUnit}
          refresh={refresh}>

          <DataTableField title="Name">
            <NameItem />
          </DataTableField>

          <DataTableField title="Symbol" dataValueName="symbol">
          </DataTableField>

          <DataTableField title="Description" dataValueName="description">
          </DataTableField>

          <DataTableField title="Created">
            <CreatedItem />
          </DataTableField>

          <DataTableField title="Modified">
            <ModifiedItem />
          </DataTableField>

        </DataTable>



      {
        createModal &&
        <DrawerForm id="modal-add-unit"
          title="Create Unit"
          buttonText="Add Unit"
          onClose={() => createModalSet(false)}
          focusOn="add-unit-name"
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("name", "Please write a valid name!", "modal-add-unit", true);
              if (callback) callback();
              return;
            }

            hub.Post(API_ROUTES.InventoryUnits, body, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Unit has been added successfully!");
              }
              if (callback) callback(res);
            })

          }}>
          <div>

            <TextBox id="add-unit-name" name="name" label="Name" marginBottom={5}
              labelUp block placeholder="E.g. Piece, Meter, Kilogram..." />

            <TextBox id="add-unit-symbol" name="symbol" label="Symbol" marginBottom={5}
              labelUp block placeholder="E.g. kg, kg, cm..." />

            <TextArea id="add-unit-descr" name="description"
              label="Description" labelUp block rows={6}
              placeholder="Write a description (optional)" />

          </div>
        </DrawerForm>
      }


      {
        editModal && selectedItem &&
        <DrawerForm id="modal-edit-unit"
          title="Edit Unit"
          buttonText="Update Unit"
          onClose={() => {
            editModalSet(false);
            selectedItemSet(undefined);
          }}
          onOpen={() => $("#edit-unit-name").focus()}
          onSubmit={(body, callback) => {

            if (window.isNullOrEmpty(body.name) || body.name.length < 2) {
              window.formError("name", "Please write a valid name!", "modal-edit-unit", true);
              if (callback) callback();
              return;
            }

            hub.Put(API_ROUTES.InventoryUnits, {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Unit has been updated successfully!");
              }
              if (callback) callback(res);
            })

          }}>
          <div>

            <TextBox id="edit-unit-name" name="name" label="Name" marginBottom={5}
              labelUp block placeholder="E.g. Piece, Meter, Kilogram..."
              value={selectedItem.name} />

            <TextBox id="edit-unit-symbol" name="symbol" label="Symbol" marginBottom={5}
              labelUp block placeholder="E.g. kg, kg, cm..."
              value={selectedItem.symbol} />

            <TextArea id="edit-unit-descr" name="description"
              label="Description" labelUp block rows={6}
              placeholder="Write a description (optional)"
              value={selectedItem.description} />

          </div>

        </DrawerForm>
      }


      {
        deleteModal && selectedItem &&
        <Modal id="modal-delete-unit"
          title="Delete Unit"
          buttonText="Confirm & Delete"
          buttonColor="danger"
          onClose={() => {
            deleteModalSet(false)
            selectedItemSet(undefined)
          }}
          onSubmit={(body, callback) => {

            hub.Post(API_ROUTES.InventoryUnits + "delete", {
              ...body,
              id: selectedItem.id
            }, res => {
              if (res.success) {
                refreshSet(true);
                toastSuccess("Unit has been deleted successfully!");
              }
              if (callback) callback(res);
            })

          }}
          staticBackdrop open visible>
          <div>
            <div className="mb-2">
              Are you sure you want to delete the unit?
            </div>
            <div className="alert alert-danger">
              {selectedItem.name}
            </div>

          </div>
        </Modal>
      }


    </>
  );
}
